import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/TaxNonTaxReport/TaxNonTaxReportAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingReportTaxNonTaxActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/TaxNonTaxReport/TaxNonTaxReport")
	}

	render() {
		return (
			<Activity 
				name="AccountingReportTaxNonTaxReport"
				RenderedComponent={this.RenderedComponent}
				context="AccountingReportTaxNonTaxReport"
				action="AccountingReportTaxNonTaxReport"
				formActions={FormAction}			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingReportTaxNonTaxActivity)
